// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_pw-0";